import { z } from "zod";
import { CitySchema, PlayerWalletSchema } from "./entities.js";
import { ConstructionJobSchema } from "./construction.js";
import { ProductionJobSchema, ProductionStateSchema } from "./production.js";
import { ResearchJobDtoSchema } from "./research.js";

/** Client → Server frames. */
export const WsClientFrameSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("subscribe"), serverId: z.number().int().positive() }),
  z.object({ type: z.literal("unsubscribe"), serverId: z.number().int().positive() }),
  z.object({ type: z.literal("ping"), ts: z.number().int().nonnegative() }),
]);
export type WsClientFrame = z.infer<typeof WsClientFrameSchema>;

/** Server → Client frames. */
export const WsServerFrameSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("hello"), serverId: z.number().int().positive(), tickMs: z.number() }),
  z.object({ type: z.literal("pong"), ts: z.number().int().nonnegative() }),
  z.object({ type: z.literal("wallet"), wallet: PlayerWalletSchema }),
  z.object({ type: z.literal("city.update"), city: CitySchema }),
  z.object({
    type: z.literal("production.complete"),
    serverId: z.number().int().positive(),
    job: ProductionJobSchema,
    state: ProductionStateSchema,
  }),
  /** §5.1 / §6.4.3 building upgrade resolver event. tick-worker publishes
   *  this when a construction_jobs row finalises and base_buildings.level
   *  bumps to targetLevel. Clients refetch the building roster. */
  z.object({
    type: z.literal("building.upgraded"),
    serverId: z.number().int().positive(),
    job: ConstructionJobSchema,
    newLevel: z.number().int().positive(),
  }),
  /** §10 research resolver event — fires when a research_jobs row finalises and
   *  player_research has been written. Clients refetch the research list. */
  z.object({
    type: z.literal("research.complete"),
    serverId: z.number().int().positive(),
    job: ResearchJobDtoSchema,
  }),
  z.object({ type: z.literal("error"), code: z.string(), message: z.string() }),
]);
export type WsServerFrame = z.infer<typeof WsServerFrameSchema>;
